export const configEnableTrue = {
  enablePivot: true,
  enableRowGroup: true,
  rowGroup: true,
};
